<div class="o-flex o-flex--grids align-items-center border-container pt-2 pb-2">
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/2@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="mb-0 text text-semibold text-left">
      {{uszkodzenie.opis}}
    </p>
  </div>
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/2@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="text-light-gray text-xs mb-0 ">
      Materiał wykończenia
    </p>
    <p class="mb-0">
      {{getMaterialWykonczenia(uszkodzenie)}}
    </p>
  </div>
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/2@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="text-light-gray text-xs mb-0 ">
      Wymiary
    </p>
    <p class="mb-0">
      {{uszkodzenie.parametry.szerokosc | number:'':language}}<span class="text-xs">m</span> x {{uszkodzenie.parametry.wysokosc | number:'':language}}<span class="text-xs">m</span>
    </p>
  </div>
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/2@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="text-light-gray text-xs mb-0 ">
      {{slownikUszkodzen.atrybuty?.etykietaWartosci}}
    </p>
    <p class="mb-0">
      {{uszkodzenie.parametry.wartosc | number:'':language}}  <span class="text-light-gray text-xs"><span *ngIf="uszkodzenie.parametry.jednostka !== 'm2' else m2">{{uszkodzenie.parametry.jednostka}}</span></span>
    </p>
  </div>
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/2@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="mb-0 float-right text-xs-center float-xs-left">
        <em class="icon-trash" (click)="usunUszkodzenie({identyfikatorUszkodzenia: uszkodzenie.identyfikator})" title="Usuń">
            <img src="assets/images/trash_bin.png" alt="Usuń">
        </em>
    </p>
  </div>
</div>

<ng-template #m2>
  <span>m<sup>2</sup></span>
</ng-template>
